export function FireIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M11.7716 12.4379C9.68877 14.5207 6.31189 14.5207 4.22909 12.4379C3.18769 11.3965 2.66699 10.0316 2.66699 8.66667C2.66699 7.30174 3.18769 5.93682 4.22909 4.89542C4.22909 4.89542 4.66702 5.99997 6.00036 6.66664C6.00036 5.3333 6.33369 3.3333 7.99091 2C9.33366 3.33333 10.7278 3.85163 11.7716 4.89542C12.813 5.93682 13.3337 7.30175 13.3337 8.66667C13.3337 10.0316 12.813 11.3965 11.7716 12.4379Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.58611 10.7475C7.36716 11.5286 8.63349 11.5286 9.41454 10.7475C9.80506 10.357 10.0003 9.84516 10.0003 9.33333C10.0003 8.82147 9.80507 8.30962 9.41454 7.91909C9.02648 7.53103 8.51864 7.33578 8.01003 7.33333L7.33362 9.33329L6.00033 9.33333C6.00033 9.84516 6.19559 10.357 6.58611 10.7475Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
